export default __webpack_public_path__ + "static/media/Sisters.c52edf49.jpeg";